import * as React from 'react';

import {DateHeader} from 'shells/date-header/date-header';
import {measureScrollbarWidth} from 'shells/utils/scrollbar';

import styles from './sticky-header.module.css';

export class StickyHeader extends React.Component<{
    children?: any;
}> {
    // @ts-expect-error
    scrollbarWidth: number;

    UNSAFE_componentWillMount() {
        this.scrollbarWidth = measureScrollbarWidth();
    }

    render() {
        return (
            <div style={{paddingRight: this.scrollbarWidth}} className={styles['sticky-header']}>
                <DateHeader>{this.props.children}</DateHeader>
            </div>
        );
    }
}
